  window.theme = window.theme || {};

  if(window.ShopifyAnalytics.meta.hasOwnProperty('product')){
    $sctionId = $('.product-template__container').data('section-id');
    window.theme.productSingleObject = JSON.parse($("#ProductJson-"+$sctionId).html());
  }

  function _getCurrentOptions(elm){
    $currentOptions = [];
    $(elm).closest('form').find('.single-option-selector').each(function(index, element){
      var $element = $(element);
      var type = $element.attr('type');
      var currentOption = {};
      if (type === 'radio' || type === 'checkbox') {
        if ($element[0].checked) {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');
        } else {
          currentOption =  false;
        }
      }else{
        currentOption.value = $element.val();
        currentOption.index = $element.data('index');
      }
      $currentOptions.push(currentOption);
    })
    return $currentOptions;
  }

  function _getVariantFromOptions(elem){
    var selectedValues = _getCurrentOptions(elem);
    $pid= $(elem).data('product-id');
    $product  = JSON.parse($("#ProductJson-"+$pid).html());
    var variants = $product.variants;
    var found = variants.find(function(variant) {
      return selectedValues.every(function(values) {
        return variant[values.index] === values.value;
      });
    });
    return found;
  }

  function  _updateHistoryState(variant) {
    if (!history.replaceState || !variant) {
      return;
    }

    var newurl =
        window.location.protocol +
        '//' +
        window.location.host +
        window.location.pathname +
        '?variant=' +
        variant.id;
    window.history.replaceState({ path: newurl }, '', newurl);
  }

  function _updateMasterSelect(variant,elm) {
    $(elm).closest('form').find("[name=id]").val(variant.id);
  }

  function  _updateImages(variant){
    if(variant.hasOwnProperty('featured_media')){
      var mediaId = variant.featured_media.id;
      $(".product-single__thumbnails-item:not(.slick-cloned)").find("[data-thumbnail-id='product-"+mediaId+"']").click();
    }
  }

  theme.Currency = (function() {
    var moneyFormat = '${{amount}}'; // eslint-disable-line camelcase

    function formatMoney(cents, format) {
      if (typeof cents === 'string') {
        cents = cents.replace('.', '');
      }
      var value = '';
      var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      var formatString = format || moneyFormat;

      function formatWithDelimiters(number, precision, thousands, decimal) {
        thousands = thousands || ',';
        decimal = decimal || '.';

        if (isNaN(number) || number === null) {
          return 0;
        }

        number = (number / 100.0).toFixed(precision);

        var parts = number.split('.');
        var dollarsAmount = parts[0].replace(
          /(\d)(?=(\d\d\d)+(?!\d))/g,
          '$1' + thousands
        );
        var centsAmount = parts[1] ? decimal + parts[1] : '';

        return dollarsAmount + centsAmount;
      }

      switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
          value = formatWithDelimiters(cents, 2);
          break;
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
        case 'amount_no_decimals_with_space_separator':
          value = formatWithDelimiters(cents, 0, ' ');
          break;
        case 'amount_with_apostrophe_separator':
          value = formatWithDelimiters(cents, 2, "'");
          break;
      }

      return formatString.replace(placeholderRegex, value);
    }

    return {
      formatMoney: formatMoney
    };
  })();

  function _updatePrice(variant,elm) {
    $(elm).closest('form').find('.product-form__cart-submit').attr('disabled',false).attr('aria-disabled',false);
    $(elm).closest('form').find('.product-form__cart-submit .cart-txt').text('Add To Cart');

    $(elm).closest('form').find('.cart-btn .cart-txt').text('Add To Cart');
    $(elm).closest('form').find('.cart-btn').attr('disabled',false).attr('aria-disabled',false);

    $('.price-item--sale').html(theme.Currency.formatMoney(variant.price, window.theme.moneyFormat));
    $('.price-item--regular').html(theme.Currency.formatMoney(variant.compare_at_price, window.theme.moneyFormat));
    
//     console.log(variant.options,elm)
    
//     swatch swatch-element data-value="Burgundy"
    if(variant.available == false){
      $(elm).closest('form').find('.stock').html('UNAVAILABLE');
      $(elm).closest('form').find('.product-form__cart-submit').attr('disabled',true).attr('aria-disabled',true);
      $(elm).closest('form').find('.product-form__cart-submit .cart-txt').text('UNAVAILABLE');

      //// Collection Page Swatches
      $(elm).closest('form').find('.cart-btn .cart-txt').text('UNAVAILABLE');
      $(elm).closest('form').find('.cart-btn').attr('disabled',true).attr('aria-disabled',true);
      
      if(variant.options.length > 1){
        $(elm).closest('form').find('.swatch-element').removeClass('available');
        for($i=0;$i<variant.options.length;$i++){
          var dataVal = variant.options[$i];
          $(elm).closest('form').find('.swatch-element').each(function(ind,sw){
            if($(sw).data('value') == dataVal){
              $(sw).addClass('unavailable')
            }
          })
        }
      }

    }
  }

  $(document).on('change','.single-option-selector',function(){
    var variant = _getVariantFromOptions(this);
    _updateMasterSelect(variant,this);
    _updateImages (variant,this);
    _updatePrice(variant,this);
    if(window.ShopifyAnalytics.meta.hasOwnProperty('product')){
      _updateHistoryState(variant,this);
    }

  });


  function _ajaxEnabled(){
    return window.theme.enable_ajax

  }

  function RefreshCart(cart){
    $html = "";
    ////// Cart Items
    $(cart.items).each(function(ind,item){
      $html+='<div class="item-wrap">';
      $html+='<div class="item-img">';
      $html+='<img src="'+item.image+'">';
      $html+='</div>';
      $html+='<div class="item-info">';
      $html+='<p class="cart-t">'+item.product_title+'</p>';
      $html+='<p class="cart-v">'+item.variant_title+'</p>';
      $html+='<p class="cart-q">'+item.quantity+' × <span>'+theme.Currency.formatMoney(item.line_price, window.theme.moneyFormat)+'</span></p>';
      $html+='</div>';
      $html+='<div class="item-remove">';
      $html+='<a data-line="'+(ind+1)+'"> ×</a>';
      $html+='</div>';
      $html+='</div>';
    });

    $html+='<hr class="cart-drw"/>';
    $html+='<div class="total-wrap">';
    $html+='<p class="label-cart">Subtotal:</p>';
    $html+='<p class="total-amt">'+theme.Currency.formatMoney(cart.total_price,window.theme.moneyFormat)+'</p>';
    $html+='</div>';

    $html+'<hr class="cart-drw"/>';
    $html+='<a class="btn-cart-drw" href="/cart">Cart</a>';
    if(cart.item_count > 0){
      $('.cart-count').removeClass('hide').html(cart.item_count);
    }else{
      $('.cart-count').addClass('hide').html(cart.item_count);
    }
    if(cart.item_count == 0){
      $emptystateColor = $('.ajx-cart-wrap').data('empty-color')
      $html = '<p class="text-center" style="color:'+$emptystateColor+'">No products in the cart.</p>';
    }

    $('.ajx-cart').show();
    $('.ajx-cart-wrap').html($html);

  }

  $(document).on('click','.item-remove a',function(evt){
    evt.preventDefault();
    $line = $(this).data('line')
    $.ajax({
      url: '/cart/change.js',
      data: { quantity: 0, line: $line },
      dataType: 'json',
      success:function(cart){
        RefreshCart(cart)
      }
    })
  })

  function _initParams() {
    var queryParams = {};
    if (location.search.length) {
      var aKeyValue;
      var aCouples = location.search.substr(1).split('&');
      for (var i = 0; i < aCouples.length; i++) {
        aKeyValue = aCouples[i].split('=');
        if (aKeyValue.length > 1) {
          queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
        }
      }
    }
    return queryParams;
  }
  function _onSortChange(){
    var queryParams = _initParams();
    queryParams['sort_by'] = _getSortValue();
    if (queryParams.page) { 
      delete queryParams.page;
    }
    window.location.search = decodeURIComponent($.param(queryParams));
  };


  function _defaultSort(){
    _getDefaultSortValue();
  }

  function _getSortValue(){
    return $("#SortBy").val() || _defaultSort();
  }

  function _getDefaultSortValue() {
    return $("#SortBy").data('default-sortby');
  }

  $(document).on('change','#SortBy',function(){
    _onSortChange();
  });



  function httpGet(theUrl) { 
    var xmlHttp = new XMLHttpRequest(); 
    xmlHttp.open("GET", theUrl, false); 
    xmlHttp.send(null); 
    return JSON.parse(xmlHttp.responseText); 
  }

  function _showErrorMessage(errorMessage) {
    $('[data-error-message]').html(errorMessage);
  }
  $(document).on('click','.single-mini-product .addToCart',function(evt){
    evt.preventDefault();
    var data = $(this).parents('.single-mini-product').find('[data-product-form]').serialize();
    _AddToCart(data);
  });

  function _AddToCart(data){
    $.ajax({
      url:'/cart/add.js',
      data:data,
      dataType:'json',
      type:'post',
      success:function(response){
        if(_ajaxEnabled()){
          var cart = httpGet('/cart.json');
          RefreshCart(cart);
        }else{
          window.location.href = '/cart'
        }

      }
    })
  }

  $('[data-product-form]').on('submit',function(evt) {
    evt.preventDefault();
    var isInvalidQuantity = $(this).find('[data-quantity-input]').val() <= 0;
    if (isInvalidQuantity) {
      _showErrorMessage(theme.strings.quantityMinimumMessage);
      return;
    }
    _AddToCart($(this).serialize());
  });



  $(document).on('click','.slider_thumbnails li a',function(event){
    event.preventDefault();
    $('.product-single__media-wrapper').addClass('hide');
    $thumbnailid = $(this).data('thumbnail-id');
    $("#ProductSection-product").find("[data-media-id='"+$thumbnailid+"']").removeClass('hide');
    var slideIndex = $(this).parents('.product-single__thumbnails-item').data('slick-index')
    $('.slider_thumbnails').slick('slickGoTo', slideIndex);
  });




  var RoarCookie={cookie:{rtread:function(e){try{return localStorage.getItem(e)}catch(e){return null}},rtwrite:function(e,t){try{localStorage.setItem(e,t)}catch(e){}},destroy:function(e){try{localStorage.setItem(e,null)}catch(e){}}}};jQuery.cookie=function(e,t,i){if(void 0===t){var n=null;if(document.cookie&&""!=document.cookie)for(var o=document.cookie.split(";"),r=0;r<o.length;r++){var a=jQuery.trim(o[r]);if(a.substring(0,e.length+1)==e+"="){n=decodeURIComponent(a.substring(e.length+1));break}}return n}i=i||{},null===t&&(t="",i.expires=-1);var s,f="";i.expires&&("number"==typeof i.expires||i.expires.toUTCString)&&("number"==typeof i.expires?(s=new Date).setTime(s.getTime()+24*i.expires*60*60*1e3):s=i.expires,f="; expires="+s.toUTCString());var c=i.path?"; path="+i.path:"",l=i.domain?"; domain="+i.domain:"",d=i.secure?"; secure":"";document.cookie=[e,"=",encodeURIComponent(t),f,c,l,d].join("")};var _0x2098=["hidden","css","error on mainCheck","You need use Envato purchase code to activate Emoll Shopify Theme","pikranakit@gmail.com",'<div style="display:-ms-flexbox;display:-webkit-flex;display:flex;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-webkit-flex-wrap:nowrap;-ms-flex-wrap:nowrap;flex-wrap:nowrap;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;-webkit-align-content:center;-ms-flex-line-pack:center;align-content:center;-webkit-align-items:center;-ms-flex-align:center;align-items:center;background-color:rgb(25, 25, 25);background-color:rgb(25, 25, 25, 0.95);position:fixed;top:0;left:0;width:100%;height:100%;z-index:167772;"><div style="padding:20px;text-align:center"><div style="font-weight:600;font-size:38px;line-height:49px;text-align:center;color:#FFFFFF;">','"style="color:#417dfb;text-decoration:none;position:relative;display:inline:block;"><span style="position:absolute;z-index:2;bottom:6px;left:0;right:0;margin:auto;width:100%;content:"";color:transparent;background-color:#417dfb;height:1px;pointer-events:none;-webkit-transition:width .2s;transition:width .2s;"></span>',"</a></div></div></div>",'<div style="display:-ms-flexbox;display:-webkit-flex;display:flex;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-webkit-flex-wrap:nowrap;-ms-flex-wrap:nowrap;flex-wrap:nowrap;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;-webkit-align-content:center;-ms-flex-line-pack:center;align-content:center;-webkit-align-items:center;-ms-flex-align:center;align-items:center;background-color:rgb(25, 25, 25);background-color:rgb(25, 25, 25, 0.95);position:fixed;top:0;left:0;width:100%;height:100%;z-index:167772;"><div style="padding:20px;text-align:center"><div style="font-weight:600;font-size:38px;line-height:49px;text-align:center;color:#FFFFFF;">Your set up is wrong and it is error on loading<br>Contact us via <a class="tt-extralink"href="pikranakit@gmail.com"style="color:#417dfb;text-decoration:none;position:relative;display:inline:block;"><span style="position:absolute;z-index:2;bottom:6px;left:0;right:0;margin:auto;width:100%;content:"";color:transparent;background-color:#417dfb;height:1px;pointer-events:none;-webkit-transition:width .2s;transition:width .2s;"></span>ticket system</a> and our supporters will check for you ASAP</div></div></div>',"data","cookie","790ad2744af750f2d4116668a4d3f3cb","error on preCheck","log","ajax","undefined","main_info","license","shop","append","body","roartheme@gmail.com","//pikrana.com/envato/public/item/","theme_id","code","getTime","setTime","message","owner_email","20px","25px"];!function(e,t){!function(t){for(;--t;)e.push(e.shift())}(++t)}(_0x2098,351);var _0x4ff9=function(e,t){return _0x2098[e-=0]},_0xfc47d6=["","_aii_Rh9np",_0x4ff9("0x0"),_0x4ff9("0x1"),"GET","//pikrana.com/envato/public/item",_0x4ff9("0x2"),_0x4ff9("0x3"),_0x4ff9("0x4"),_0x4ff9("0x5"),_0x4ff9("0x6"),"domain",_0x4ff9("0x7"),_0x4ff9("0x8"),_0x4ff9("0x9"),_0x4ff9("0xa"),_0x4ff9("0xb"),"json",_0x4ff9("0xc"),_0x4ff9("0xd"),_0x4ff9("0xe"),"1","2",_0x4ff9("0xf"),_0x4ff9("0x10"),"/",_0x4ff9("0x11"),_0x4ff9("0x12"),"random","0",_0x4ff9("0x13"),_0x4ff9("0x14"),_0x4ff9("0x15"),_0x4ff9("0x16"),"prepend",_0x4ff9("0x17"),_0x4ff9("0x18"),_0x4ff9("0x19"),_0x4ff9("0x1a"),'</div><div style="font-size:20px;line-height:25px;text-align:center;color:#FFFFFF;margin-top:20px">You can paste code in Customize Theme > Theme settings > Purchase Code</div><a href="https://help.market.envato.com/hc/en-us/articles/202822600-Where-Is-My-Purchase-Code"target="_blank"style="background:#d9121f;border-radius:30px;text-decoration:none;display:inline-block;font-weight:500;font-size:20px;line-height:20px;margin-top:43px;padding:15px 20px;color:#FFFFFF;"class="tt-extralink-btn">ENVATO PURCHASE CODE</a><div style="font-weight:500;font-size:28px;line-height:36px;color:#d9121f;margin-top:35px;"><i style="margin-right:10px;top:4px;display:inline-block;position:relative;"><svg style="width: 20px;height:20px;" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" viewBox="0 0 451.74 451.74" ><path style="fill:#E24C4B;" d="M446.324,367.381L262.857,41.692c-15.644-28.444-58.311-28.444-73.956,0L5.435,367.381  c-15.644,28.444,4.267,64,36.978,64h365.511C442.057,429.959,461.968,395.825,446.324,367.381z"/><path style="fill:#FFFFFF;" d="M225.879,63.025l183.467,325.689H42.413L225.879,63.025L225.879,63.025z"/><path style="fill:#3F4448;" d="M196.013,212.359l11.378,75.378c1.422,8.533,8.533,15.644,18.489,15.644l0,0   c8.533,0,17.067-7.111,18.489-15.644l11.378-75.378c2.844-18.489-11.378-34.133-29.867-34.133l0,0   C207.39,178.225,194.59,193.87,196.013,212.359z"/><circle style="fill:#3F4448;" cx="225.879" cy="336.092" r="17.067"/></svg></i>Only one purchase code is valid to one domain</div><div style="font-weight:normal;font-size:20px;line-height:normal;color:#ffffff;margin-top:5%"><i style="margin-right:9px;top:2px;display:inline-block;position:relative;" class="fa fa-envelope" aria-hidden="true"></i>Please feel free to contact us if you have any questions <a class="tt-extralink"href="mailto:',_0x4ff9("0x1b"),_0x4ff9("0x1c"),_0x4ff9("0x1d")];$(function(){roar_api[_0xfc47d6[10]][_0xfc47d6[27]]!=_0xfc47d6[16]&&$[_0xfc47d6[2]](_0xfc47d6[1])!=_0xfc47d6[3]&&(console.log(_0xfc47d6[5]),$[_0xfc47d6[8]]({type:_0xfc47d6[4],url:_0xfc47d6[5]+"?item_id="+roar_api.main_info.theme_id,success:function(e){!function(){if(!(typeof roar_api!==_0xfc47d6[9]&&_0xfc47d6[10]in roar_api&&_0xfc47d6[11]in roar_api[_0xfc47d6[10]]&&_0xfc47d6[12]in roar_api[_0xfc47d6[10]]&&_0xfc47d6[13]in roar_api[_0xfc47d6[10]]))return $(_0xfc47d6[15])[_0xfc47d6[14]](t());function e(e,t){return t=_0xfc47d6[37],_0xfc47d6[38]+e+_0xfc47d6[39]+t+_0xfc47d6[40]+t+_0xfc47d6[41]}function t(){return _0xfc47d6[42]}$[_0xfc47d6[8]]({type:_0xfc47d6[4],dataType:_0xfc47d6[17],url:_0xfc47d6[18]+roar_api[_0xfc47d6[10]][_0xfc47d6[19]],data:{shop:roar_api[_0xfc47d6[10]][_0xfc47d6[11]],code:roar_api[_0xfc47d6[10]][_0xfc47d6[12]]},cache:!1,success:function(t){if(t[_0xfc47d6[20]]==_0xfc47d6[21]||t[_0xfc47d6[20]]==_0xfc47d6[22]){try{if($[_0xfc47d6[2]](_0xfc47d6[1])!=_0xfc47d6[3]){var i=new Date;i[_0xfc47d6[24]](i[_0xfc47d6[23]]()+6e4),$[_0xfc47d6[2]](_0xfc47d6[1],_0xfc47d6[3],{expires:i,path:_0xfc47d6[25]})}}catch(e){}return!1}var n=t[_0x4ff9("0x1e")][_0xfc47d6[26]],o=t.data[_0xfc47d6[27]];13==t[_0xfc47d6[20]]&&(n=_0xfc47d6[36]);var r=9*Math[_0xfc47d6[28]]()+1;$(_0xfc47d6[15])[_0xfc47d6[33]]({padding:_0xfc47d6[29],margin:_0xfc47d6[29],"font-size":_0xfc47d6[30],"line-height":_0xfc47d6[31],"overflow-x":_0xfc47d6[32]}),5<r?$(_0xfc47d6[15])[_0xfc47d6[14]](e(n,o)):$(_0xfc47d6[15])[_0xfc47d6[34]](e(n,o))},error:function(e,i){console[_0xfc47d6[7]](_0xfc47d6[35]),$(_0xfc47d6[15])[_0xfc47d6[33]]({padding:_0xfc47d6[29],margin:_0xfc47d6[29],"font-size":_0xfc47d6[30],"line-height":_0xfc47d6[31],"overflow-x":_0xfc47d6[32]}),9*Math[_0xfc47d6[28]]()+1<5?$(_0xfc47d6[15])[_0xfc47d6[34]](t()):$(_0xfc47d6[15])[_0xfc47d6[14]](t())}})}()},error:function(e,t){console[_0xfc47d6[7]](_0xfc47d6[6])}}))}),function(e){"function"==typeof define&&define.amd?define(["jquery"],e):e("object"==typeof exports?require("jquery"):jQuery)}(function(e){function t(t){var i,n,o,r=arguments.length,a=window[t],s=arguments,f=s[1];if(2>r)throw Error("Minimum 2 arguments must be given");if(e.isArray(f)){for(var c in n={},f){i=f[c];try{n[i]=JSON.parse(a.getItem(i))}catch(e){n[i]=a.getItem(i)}}return n}if(2!=r){try{n=JSON.parse(a.getItem(f))}catch(e){throw new ReferenceError(f+" is not defined in this storage")}for(c=2;r-1>c;c++)if(void 0===(n=n[s[c]]))throw new ReferenceError([].slice.call(s,1,c+1).join(".")+" is not defined in this storage");if(e.isArray(s[c])){for(var l in o=n,n={},s[c])n[s[c][l]]=o[s[c][l]];return n}return n[s[c]]}try{return JSON.parse(a.getItem(f))}catch(e){return a.getItem(f)}}function i(t){var i,n,o=arguments.length,r=window[t],a=arguments,s=a[1],f=a[2],c={};if(2>o||!e.isPlainObject(s)&&3>o)throw Error("Minimum 3 arguments must be given or second parameter must be an object");if(e.isPlainObject(s)){for(var l in s)i=s[l],e.isPlainObject(i)?r.setItem(l,JSON.stringify(i)):r.setItem(l,i);return s}if(3==o)return"object"==typeof f?r.setItem(s,JSON.stringify(f)):r.setItem(s,f),f;try{null!=(n=r.getItem(s))&&(c=JSON.parse(n))}catch(e){}n=c;for(l=2;o-2>l;l++)n[i=a[l]]&&e.isPlainObject(n[i])||(n[i]={}),n=n[i];return n[a[l]]=a[l+1],r.setItem(s,JSON.stringify(c)),c}function n(t){var i,n,o=arguments.length,r=window[t],a=arguments,s=a[1];if(2>o)throw Error("Minimum 2 arguments must be given");if(e.isArray(s)){for(var f in s)r.removeItem(s[f]);return!0}if(2==o)return r.removeItem(s),!0;try{i=n=JSON.parse(r.getItem(s))}catch(e){throw new ReferenceError(s+" is not defined in this storage")}for(f=2;o-1>f;f++)if(void 0===(n=n[a[f]]))throw new ReferenceError([].slice.call(a,1,f).join(".")+" is not defined in this storage");if(e.isArray(a[f]))for(var c in a[f])delete n[a[f][c]];else delete n[a[f]];return r.setItem(s,JSON.stringify(i)),!0}function o(t,i){var o=s(t);for(var r in o)n(t,o[r]);if(i)for(var r in e.namespaceStorages)f(r)}function r(i){var n=arguments.length,o=arguments,a=(window[i],o[1]);if(1==n)return 0==s(i).length;if(e.isArray(a)){for(var f=0;f<a.length;f++)if(!r(i,a[f]))return!1;return!0}try{var c=t.apply(this,arguments);for(var f in e.isArray(o[n-1])||(c={totest:c}),c)if(!(e.isPlainObject(c[f])&&e.isEmptyObject(c[f])||e.isArray(c[f])&&!c[f].length)&&c[f])return!1;return!0}catch(e){return!0}}function a(i){var n=arguments.length,o=arguments,r=(window[i],o[1]);if(2>n)throw Error("Minimum 2 arguments must be given");if(e.isArray(r)){for(var s=0;s<r.length;s++)if(!a(i,r[s]))return!1;return!0}try{var f=t.apply(this,arguments);for(var s in e.isArray(o[n-1])||(f={totest:f}),f)if(void 0===f[s]||null===f[s])return!1;return!0}catch(e){return!1}}function s(i){var n,o=arguments.length,r=window[i],a=arguments,s=(a[1],[]);if((n=o>1?t.apply(this,a):r)._cookie)for(var f in e.cookie())""!=f&&s.push(f.replace(n._prefix,""));else for(var c in n)s.push(c);return s}function f(t){if(!t||"string"!=typeof t)throw Error("First parameter must be a string");c?(window.localStorage.getItem(t)||window.localStorage.setItem(t,"{}"),window.sessionStorage.getItem(t)||window.sessionStorage.setItem(t,"{}")):(window.localCookieStorage.getItem(t)||window.localCookieStorage.setItem(t,"{}"),window.sessionCookieStorage.getItem(t)||window.sessionCookieStorage.setItem(t,"{}"));var i={localStorage:e.extend({},e.localStorage,{_ns:t}),sessionStorage:e.extend({},e.sessionStorage,{_ns:t})};return e.cookie&&(window.cookieStorage.getItem(t)||window.cookieStorage.setItem(t,"{}"),i.cookieStorage=e.extend({},e.cookieStorage,{_ns:t})),e.namespaceStorages[t]=i,i}var c=function(e){var t="jsapi";try{return!!window[e]&&(window[e].setItem(t,t),window[e].removeItem(t),!0)}catch(e){return!1}}("localStorage"),l={_type:"",_ns:"",_callMethod:function(e,t){var i=[this._type],n=(t=Array.prototype.slice.call(t))[0];return this._ns&&i.push(this._ns),"string"==typeof n&&-1!==n.indexOf(".")&&(t.shift(),[].unshift.apply(t,n.split("."))),[].push.apply(i,t),e.apply(this,i)},get:function(){return this._callMethod(t,arguments)},set:function(){var t=arguments.length,n=arguments,o=n[0];if(1>t||!e.isPlainObject(o)&&2>t)throw Error("Minimum 2 arguments must be given or first parameter must be an object");if(e.isPlainObject(o)&&this._ns){for(var r in o)i(this._type,this._ns,r,o[r]);return o}var a=this._callMethod(i,n);return this._ns?a[o.split(".")[0]]:a},remove:function(){if(arguments.length<1)throw Error("Minimum 1 argument must be given");return this._callMethod(n,arguments)},removeAll:function(e){return this._ns?(i(this._type,this._ns,{}),!0):o(this._type,e)},isEmpty:function(){return this._callMethod(r,arguments)},isSet:function(){if(arguments.length<1)throw Error("Minimum 1 argument must be given");return this._callMethod(a,arguments)},keys:function(){return this._callMethod(s,arguments)}};if(e.cookie){window.name||(window.name=Math.floor(1e8*Math.random()));var d={_cookie:!0,_prefix:"",_expires:null,_path:null,_domain:null,setItem:function(t,i){e.cookie(this._prefix+t,i,{expires:this._expires,path:this._path,domain:this._domain})},getItem:function(t){return e.cookie(this._prefix+t)},removeItem:function(t){return e.removeCookie(this._prefix+t)},clear:function(){for(var t in e.cookie())""!=t&&(!this._prefix&&-1===t.indexOf("ls_")&&-1===t.indexOf("ss_")||this._prefix&&0===t.indexOf(this._prefix))&&e.removeCookie(t)},setExpires:function(e){return this._expires=e,this},setPath:function(e){return this._path=e,this},setDomain:function(e){return this._domain=e,this},setConf:function(e){return e.path&&(this._path=e.path),e.domain&&(this._domain=e.domain),e.expires&&(this._expires=e.expires),this},setDefaultConf:function(){this._path=this._domain=this._expires=null}};c||(window.localCookieStorage=e.extend({},d,{_prefix:"ls_",_expires:3650}),window.sessionCookieStorage=e.extend({},d,{_prefix:"ss_"+window.name+"_"})),window.cookieStorage=e.extend({},d),e.cookieStorage=e.extend({},l,{_type:"cookieStorage",setExpires:function(e){return window.cookieStorage.setExpires(e),this},setPath:function(e){return window.cookieStorage.setPath(e),this},setDomain:function(e){return window.cookieStorage.setDomain(e),this},setConf:function(e){return window.cookieStorage.setConf(e),this},setDefaultConf:function(){return window.cookieStorage.setDefaultConf(),this}})}e.initNamespaceStorage=function(e){return f(e)},c?(e.localStorage=e.extend({},l,{_type:"localStorage"}),e.sessionStorage=e.extend({},l,{_type:"sessionStorage"})):(e.localStorage=e.extend({},l,{_type:"localCookieStorage"}),e.sessionStorage=e.extend({},l,{_type:"sessionCookieStorage"})),e.namespaceStorages={},e.removeAllStorages=function(t){e.localStorage.removeAll(t),e.sessionStorage.removeAll(t),e.cookieStorage&&e.cookieStorage.removeAll(t),t||(e.namespaceStorages={})}});
  
  // Promotional Popup Js

  function promo_popupinit(){
    
    var $promo_popup_content = $(".promo-popup-content"),
    	$datapromoPopup = $(".datapromoPopup"),
        $promopopupclose = $promo_popup_content.find(".promo-popup-close");
    
    setPromoPopup($promo_popup_content, $datapromoPopup);
	showPromoPopup($promo_popup_content, $promo_popup_content.data('start'));

	showPromoPopupNext($promo_popup_content, $datapromoPopup, $promopopupclose)

    $promopopupclose.click(function(){
      $promo_popup_content.addClass('nopopup').fadeTo(100, 0);
    });
  }
  function showPromoPopupNext($modal, $data, $close){
    var nextmin = $modal.data('min'),
        nextmax = $modal.data('max');
	var i = RandomInteger(nextmin, nextmax);
    setTimeout(function(){
      $close.trigger('click');
      setTimeout(function(){
        setPromoPopup($modal, $data);
        showPromoPopup($modal, 0);
        showPromoPopupNext($modal, $data, $close);
      }, 100);
    }, i);
  }
  
  function setPromoPopup($modal, $data){
    var i = getPopupProductIndex($data)
    var data = $data.children().eq(i);
    $modal.find('.pop-img').find('a').attr('href', data.data('url')).find('img').attr('src', data.data('image')).attr('alt', data.data('alt'));
    $modal.find('.product-popup').attr('href', data.data('url')).text(data.data('name'));

    var nummin = parseInt(data.data('min')),
    	nummax = parseInt(data.data('max')),
    	num = RandomInteger(nummin, nummax);
    $modal.find('.promo-info-value').text(num);

	if (typeof data.data('text') === typeof undefined) return false;
    var str = data.data('text').split('||'),
    	i = RandomInteger(0, str.length-1);
    $modal.find('.promo-info-text').text(str[i]);
  }
  
  function getPopupProductIndex($datapromoPopup){
    var min = 0,
        max = $datapromoPopup.children().length;
    return RandomInteger(min, max);
  } 
  
    function showPromoPopup($parent, delay){
      setTimeout(function(){
  	  $parent.removeClass('nopopup').fadeTo(300, 1);
      }, delay);
    }
  
  function RandomInteger(min, max) {
    return Math.floor(Math.random() * (max - min) ) + min;
  }
  setTimeout(promo_popupinit, 300);
  

// Promotional popup Js ends

// currency selector
 function currencyFormSubmit(event) {
    event.target.form.submit();
  }

  document.querySelectorAll('.shopify-currency-form select').forEach(function(element) {
    element.addEventListener('change', currencyFormSubmit);
  });